import React, { useState } from "react";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";
const TITLE = "حاسبة مدة تعلم اللغة الألمانية";
const DESCRIPTION =
  "اكتشف كم من الوقت قد يستغرق تعلم اللغة الألمانية بناءً على المستوى الذي تريد الوصول إليه.";
const KEYWORDS = "تعلم اللغة الألمانية, حاسبة, الوقت اللازم, اللغة الألمانية";
const OG_URL =
  "https://do-calculate.com/calculator/ar/german-learning-time-calculator/";
function GermanLearningTimeCalculator() {
  const [lessonsPerWeek, setLessonsPerWeek] = useState("");
  const [lessonTime, setLessonTime] = useState("");
  const [timeUnit, setTimeUnit] = useState("minutes");
  const [timeFormat, setTimeFormat] = useState("weeks");
  const [totalWeeklyHours, setTotalWeeklyHours] = useState("");
  const [timeToLevels, setTimeToLevels] = useState({});
  const [error, setError] = useState("");
  const LEVELS = {
    A1: 100,
    A2: 200,
    B1: 350,
    B2: 600,
    C1: 750,
    C2: 1000,
  };
  const calculateTotalHours = (lessonsPerWeek, lessonTime, timeUnit) => {
    const lessonTimeInHours =
      timeUnit === "minutes"
        ? parseFloat(lessonTime) / 60
        : parseFloat(lessonTime);
    return parseFloat(lessonsPerWeek) * lessonTimeInHours;
  };
  const calculateTimeForLevels = (totalWeeklyHours) => {
    let timeToLevels = {};
    let accumulatedHours = 0;
    Object.entries(LEVELS).forEach(([level, hoursRequired], index) => {
      accumulatedHours += hoursRequired;
      const weeks = accumulatedHours / totalWeeklyHours;
      timeToLevels[level] = formatTime(weeks);
    });
    return timeToLevels;
  };
  const formatTime = (weeks) => {
    switch (timeFormat) {
      case "days":
        return (weeks * 7).toFixed(1) + " أيام";
      case "months":
        return (weeks / 4).toFixed(1) + " شهور";
      case "years":
        return (weeks / 52).toFixed(1) + " سنوات";
      default:
        return weeks.toFixed(1) + " أسابيع";
    }
  };
  const handleCalculate = () => {
    try {
      const lessonsPerWeekValue = parseFloat(lessonsPerWeek);
      const lessonTimeValue = lessonTime.includes(":")
        ? parseFloat(lessonTime.split(":")[0]) +
          parseFloat(lessonTime.split(":")[1]) / 60
        : parseFloat(lessonTime);
      if (lessonsPerWeek && lessonTime) {
        const totalHours = calculateTotalHours(
          lessonsPerWeekValue,
          lessonTimeValue,
          timeUnit
        );
        setTotalWeeklyHours(totalHours.toFixed(2) + " ساعات بالأسبوع");
        const levelsTime = calculateTimeForLevels(totalHours);
        setTimeToLevels(levelsTime);
        setError("");
      } else {
        throw new Error("يرجى إدخال عدد الدروس في الأسبوع و متوسط مدة الدرس.");
      }
    } catch (err) {
      setError(err.message);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  تساعدك هذه الحاسبة في تقدير الوقت الذي قد تحتاجه لتعلم اللغة
                  الألمانية بناءً على المستوى الذي ترغب في الوصول إليه.
                </p>
                <p>
                  يعتمد ذلك بشكل كبير على مستوى اللغة الذي تريد تحقيقه. هل ترغب
                  في التواصل اليومي مع الألمان؟ أم في مجال الأعمال أو السياسة؟
                </p>
                <ul>
                  <li>كلما زاد المستوى، زادت الحاجة إلى الوقت.</li>
                  <li>التعلم يحتاج إلى موهبة خاصة وقدرة على استيعاب اللغات.</li>
                </ul>
                <p>
                  تذكر أن هذه التقديرات تقريبية وتعتمد بشكل كبير على الشخص
                  وقدرته على التعلم.
                </p>
                <p>
                  تم تطوير الحاسبة بلاعتماد على{" "}
                  <a
                    href="https://www.maxmuellerinstitute.com/german-language-courses-a1-c1"
                    rel="nofollow"
                  >
                    Max Mueller Institute
                  </a>
                </p>
                <hr />
              </div>
              <br />
            </div>
             <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-10 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div dir="rtl">
                  <div>
                    <hr />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          دروس في الأسبوع
                        </label>
                      </b>
                      <input
                        type="number"
                        placeholder="أدخل عدد الدروس"
                        value={lessonsPerWeek}
                        onChange={(e) => setLessonsPerWeek(e.target.value)}
                        className="form-control"
                        style={{ width: "50%" }}
                      />
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label htmlFor="timeUnit" className="form-label ms-2">
                          متوسط مدة الدرس
                        </label>
                      </b>
                      <input
                        type="text"
                        placeholder="أدخل مدة الدرس"
                        value={lessonTime}
                        onChange={(e) => setLessonTime(e.target.value)}
                        className="form-control"
                        style={{ width: "50%" }}
                      />
                      <select
                        id="timeUnit"
                        value={timeUnit}
                        onChange={(e) => setTimeUnit(e.target.value)}
                        className="form-select ms-2"
                        style={{ width: "25%" }}
                      >
                        <option value="minutes">دقائق</option>
                        <option value="hours">ساعات</option>
                      </select>
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label htmlFor="timeFormat" className="form-label ms-2">
                          صيغة الوقت للمستويات
                        </label>
                      </b>
                      <select
                        id="timeFormat"
                        value={timeFormat}
                        onChange={(e) => setTimeFormat(e.target.value)}
                        className="form-select ms-2"
                        style={{ width: "25%" }}
                      >
                        <option value="days">أيام</option>
                        <option value="weeks">أسابيع</option>
                        <option value="months">شهور</option>
                        <option value="years">سنوات</option>
                      </select>
                    </div>
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      احسب                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      خطأ: {error}
                    </p>
                  )}
                  {totalWeeklyHours &&  (
                    <div className="p-3 mb-2 bg-success text-white">
                      <hr />
                      <p> النتائج:</p>
                      <p>
                        {" "}
                        إجمالي الساعات الأسبوعية: <b>{totalWeeklyHours}</b>
                      </p>
                      <p>
                        {" "}
                        <b>{timeToLevels.A1}</b> هو الوقت من المستوى A1 إلى A2
                      </p>
                      <p>
                        <b>{timeToLevels.A2}</b> هو الوقت من المستوى A2 إلى B1
                      </p>
                      <p>
                        <b>{timeToLevels.B1}</b> هو الوقت من المستوى B1 إلى B2
                      </p>
                      <p>
                        <b>{timeToLevels.B2}</b> هو الوقت من المستوى B2 إلى C1
                      </p>
                      <p>
                        <b>{timeToLevels.C1}</b> هو الوقت من المستوى C1 إلى C2
                      </p>
                      <p>
                        <b>{timeToLevels.C2}</b> هو إجمالي الوقت من المستوى A1
                        إلى C2
                      </p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                معلومات حول تعلم اللغة الألمانية
              </div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      مدة تعلم اللغة الألمانية
                    </h2>{" "}
                  </u>
                  <p>
                    يعتمد الوقت الذي تحتاجه لتعلم اللغة الألمانية على العديد من
                    العوامل، بما في ذلك مستوى الإلمام المطلوب.
                  </p>
                  <p>
                    إذا كنت ترغب في التعامل مع الحياة اليومية، فقد تحتاج إلى
                    حوالي 3 أشهر للوصول إلى مستوى مقبول.
                  </p>
                  <div className="p-3 mb-2 bg-info">
                    مثال: إذا كنت بحاجة للتعامل في بيئة عمل، قد تحتاج إلى
                    استثمار المزيد من الوقت لتحقيق مستوى B2 أو أعلى.
                  </div>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      التحديات في تعلم اللغة الألمانية
                    </h2>{" "}
                  </u>
                  <p>
                    قد تواجه بعض الصعوبات مثل تعلم المقالات "Die, Der, Das" التي
                    تتغير مع الحالات الإعرابية.
                  </p>
                  <ul>
                    <li>
                      لا توجد قواعد ثابتة لهذه المقالات، لذا يجب تعلمها بالتدريب
                      والممارسة.
                    </li>
                    <li>
                      اللغة الألمانية تتطلب ممارسة مستمرة وفهم جيد للقواعد.
                    </li>
                  </ul>
                  <p>ولكن مع المثابرة، يمكنك التغلب على هذه التحديات.</p>
                  <div className="p-3 mb-2 bg-info text-black">
                    مثال: حتى مع الإقامة الطويلة في ألمانيا، قد تستمر بعض
                    التحديات مثل استخدام المقالات الصحيحة.
                  </div>
                  <hr />
                </div>
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      طرق تحسين تعلم اللغة الألمانية
                    </h2>{" "}
                  </u>
                  <p>
                    {" "}
                    يمكن تحسين تعلم اللغة الألمانية من خلال الاستماع المستمر
                    والتحدث مع الناطقين بها.
                  </p>
                  <ul>
                    <li>
                      الالتحاق بدورات اللغة الألمانية يمكن أن يساهم بشكل كبير في
                      تحسين مهاراتك.
                    </li>
                    <li>
                      التحدث مع السكان المحليين يعزز من مستوى اللغة بشكل أسرع.
                    </li>
                  </ul>
                  <p>
                    أيضًا، الانخراط في الأنشطة اليومية باستخدام اللغة الألمانية
                    سيساعدك على التقدم بسرعة.
                  </p>
                  <b>مثال</b>
                  <div className="p-3 mb-2 bg-info text-black ">
                    يمكن أن يكون التعلم الذاتي معززًا بشكل كبير من خلال تطبيقات
                    التعلم مثل Duolingo وBabbel.
                  </div>
                </div>
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>الأسئلة الشائعة</h2>{" "}
                  </u>
                  <p>
                    يمكن أن تتفاوت تجربة تعلم اللغة من شخص لآخر بناءً على
                    قدراته.
                  </p>
                  <b>مثال</b>
                  <div className="p-3 mb-2 bg-info text-black ">
                    ما هو أفضل أسلوب لتعلم اللغة الألمانية بسرعة؟ الإجابة:
                    الممارسة اليومية والتحدث مع المتحدثين الأصليين.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default GermanLearningTimeCalculator;
